import Table from 'components/commons/table'
import { Button } from 'avo-ui'
import Search from 'components/commons/search'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import { TABLE_ORDER } from 'configs/user/user-detail/configTableOrder'
import ModalExport from 'components/commons/modal-export'

export const TabOrder = ({ dataList, query, onChangeQuery, modalExport, setModalExport, onExport, isLoading }) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex space-x-3'}>
                <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                <Button
                    title={'Export'}
                    icon={icLinkExternal}
                    type={'outline'}
                    disabled={!dataList?.total_result}
                    onClick={() => setModalExport(true)}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_ORDER.name}
                columns={TABLE_ORDER.column}
                data={dataList?.results}
                size={20}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
            />
            {modalExport && (
                <ModalExport
                    show={modalExport}
                    onHide={() => setModalExport(false)}
                    description={'Are You Sure Export This?'}
                    totalData={dataList?.total_result}
                    isLoading={false}
                    onExport={onExport}
                />
            )}
        </div>
    )
}
